import { render, staticRenderFns } from "./ActivationsForm.vue?vue&type=template&id=44d19718&"
import script from "./ActivationsForm.vue?vue&type=script&lang=js&"
export * from "./ActivationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports